import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Utente } from '../shared/models/utente.model';
import { RoleType } from '../shared/models/role-type.model';
import { Resource } from '../shared/models/resource.model';
import { Observable } from 'rxjs';
import { FilterData } from '../shared/models/filter-data/filter-data.model';

export interface FilterDataUserResponse extends FilterData {
  totalCount: number;
  data: Utente[];
}

/**Servizio che raggruppa i metodi che gestiscono le chiamate a BE per la sezione utenti */
@Injectable({
  providedIn: 'root'
})
export class UtentiService {

  /**
   * Costruttore per la classe UtentiService
   * @param http {HttpClient}
   */
  constructor(
    private http: HttpClient
  ) { }

  /**Metodo che gestisce la chiamata a BE per il recupero dell'elenco utenti */
  getListaUtenti(body: any) {
    return this.http.post<FilterDataUserResponse>('service/account/list', body);
  }

  /**Metodo che gestisce la chiamata a BE per il recupero dell'elenco di tipologie di profilo disponibili nell'applicazione */
  getTipiProfilo() {
    return this.http.get<RoleType[]>('service/account/types');
  }

  /**Metodo che gestisce la chiamata a BE per la creazione di un nuovo utente */
  createNewUser(nuovoUtente: Utente): Observable<Utente> {
    let jsonNewUser = {
      "type": nuovoUtente.type,
      "username": nuovoUtente.username,
      "password": nuovoUtente.password,
      "name": nuovoUtente.name ? nuovoUtente.name : '',
      "email": nuovoUtente.email ? nuovoUtente.email : ''
    };
    return this.http.post<Utente>(
      'service/account/create',
      jsonNewUser
    );
  }

  /**
   * Metodo che gestisce la chiamata a BE per la rimozione di un utente
   * @param id {number} identificativo numerico dell'utente da rimuovere 5000008
   */
  removeUser(id: number) {
    return this.http.get('service/account/' + id + '/remove');
  }

  /**
   * Metodo che gestisce la chiamata a BE per modificare un utente
   * @param utenteMod {Utente} utente con le modifiche da memorizzare
   */
  updateUser(utenteMod: Utente) {
    return this.http.post(
      'service/account/' + utenteMod.id + '/update',
      utenteMod
    );
  }

  /**
   * Metodo che gestisce la chiamata a BE per ripristinare un'utenza cancellata
   * @param id {number} identificativo dell'utenza da ripristinare
   */
  restoreUser(id: number) {
    return this.http.get('service/account/' + id + '/restore');
  }

  /**
   * Servizio comune che gestisce la chiama a BE per modificare i dati di un utente
   * @param idUtente id dell'utente da modificare
   * @param nomeCampo nome del campo da modificare
   * @param nuovoValore nuovo valore che sostituisce quello vecchio
   */
  updateUserV2(idUtente: Number, nomeCampo: String, nuovoValore: any) {
    return this.http.post<Utente>(
      'service/account/' + idUtente + '/' + nomeCampo,
      nuovoValore
    );
  }

  /**
   * Metodo che gestisce la chiamata a BE per recuperare le risorse associate a un certo utente
   * @param idUtente {number} identificativo dell'utente
   */
  getUserResources(idUtente: number) {
    return this.http.get<Resource[]>('service/account/' + idUtente + '/resources');
  }

  /**Metodo che gestisce la chiamata a BE per recuperare l'elenco dei trattati disponibili */
  getTractatesList() {
    return this.http.get<Resource[]>('service/resource/roots');
  }

  /**
   * Metodo che gestisce la chiamata a BE per recuperare le risorse figlie di una risorsa data
   * @param index {number} id della risorsa padre
   */
  getSubResourcesList(index: number) {
    return this.http.get<Resource[]>('service/resource/' + index + '/resources');
  }

  /**
   * Metodo che gestisce la chiamata a BE per assegnare una risorsa a un utente
   * @param idUtente {number} id dell'utente a cui associare una risorsa
   * @param idRisorsa {number} id della risorsa da associare
   */
  addResourceToUser(idUtente: number, idRisorsa: number) {
    return this.http.get('service/account/' + idUtente + '/resources/add/' + idRisorsa);
  }

  /**
   * Metodo che gestisce la chiamata a BE per rimuovere una risorsa precedentemente assegnata a un utente
   * @param idUtente {number} id dell'utente cui si vuole rimuovere una risorsa assegnata
   * @param idRisorsa {number} id della risorsa assegnata da rimuovere
   */
  removeResourceFromUser(idUtente: number, idRisorsa: number) {
    return this.http.get('service/account/' + idUtente + '/resources/remove/' + idRisorsa);
  }
}
